var render, staticRenderFns
import script from "./dakaType.vue?vue&type=script&lang=js"
export * from "./dakaType.vue?vue&type=script&lang=js"
import style0 from "./dakaType.vue?vue&type=style&index=0&id=bd355daa&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd355daa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd355daa')) {
      api.createRecord('bd355daa', component.options)
    } else {
      api.reload('bd355daa', component.options)
    }
    
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/sign_group/form/components/dakaType.vue"
export default component.exports